import classnames from 'classnames'
import { CloseIcon } from 'components/icons'
import css from './styles.scss'

interface CloseButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}

function CloseButton({ onClick }: CloseButtonProps) {
  return (
    <button
      aria-label="Close"
      className={classnames(
        'btn-unstyled flex justify-center align-center',
        css.closeButton
      )}
      type="button"
      onClick={onClick}
    >
      <CloseIcon height="13" />
    </button>
  )
}

interface Composable {
  /**
   * Allows you to use the given component as the root renderer.
   * PS: Must be a valid react element (jsx).
   *
   * @default undefined
   */
  Component?: React.ReactElement
}

export interface DismissibleBannerProps
  extends Composable,
    React.HTMLAttributes<HTMLDivElement> {
  /**
   * If provided, it will render the close button and fire this callback.
   *
   * @default undefined
   */
  onClose?: () => void

  /** Temporary hack to allow Control variant to be centered on mobile
   * while other variant is not.
   */
  centeredOnMobile?: boolean
}

export default function DismissibleBanner({
  Component,
  children,
  className,
  onClose,
  centeredOnMobile,
  ...rest
}: DismissibleBannerProps) {
  return (
    <div className={classnames(css.bannerWrapper, className)} {...rest}>
      <div
        className={classnames(
          css.contentWrapper,
          centeredOnMobile && css.centeredOnMobile
        )}
      >
        {children}
      </div>
      {onClose && <CloseButton onClick={onClose} />}
    </div>
  )
}
